import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs/Observable";
import { NameId } from "../models/nameId";
import { saveAs as importedSaveAs } from "file-saver";
import { HttpClient } from "@angular/common/http";
import { PartnerResponse } from "app/models/partner-response";
import { Partner } from "app/models/partner";

const URL = environment.apiBaseUrl;

@Injectable()
export class PartnerService {
  constructor(private http: HttpClient) {}

  public partners(
    startRow: number,
    endRow: number,
    searchText: string,
    sortCol: string,
    sortDesc: boolean,
    showInactive: boolean
  ): Observable<PartnerResponse> {
    const url =
      `${URL}partners?startRow=${startRow}&endRow=${endRow}&searchString=${searchText}` +
      `&sortColumn=${sortCol}&sortDescending=${sortDesc}&showInactive=${showInactive}`;

    return this.http.get(url).map((x: any) => {
      const res: PartnerResponse = {
        partners: x.data as Partner[],
        total: x.total
      };
      return res;
    });
  }

  public getPartner(id: string): Observable<Partner> {
    return this.http.get<Partner>(`${URL}partners/${id}`);
  }

  public updatePartner(partner: Partner) {
    return this.http.put(`${URL}partners`, partner);
  }

  public addPartner(partner: Partner) {
    return this.http.post(`${URL}partners`, partner);
  }

  public deactivate(id: number) {
    return this.http.post(`${URL}partners/deactivate/${id}`, null);
  }

  public activate(id: number) {
    return this.http.post(`${URL}partners/activate/${id}`, null);
  }

  public getAllSimple(): Observable<NameId[]> {
    return this.http.get<NameId[]>(`${URL}/partners/allSimple`);
  }

  public downloadPayout(
    partner: Partner,
    quarterId: number,
    quarterName: string
  ) {
    return this.http
      .get(`${URL}partners/payout/${partner.id}/${quarterId}`, {
        responseType: "blob"
      })
      .subscribe((res: any) => {
        const filename = `${quarterName} ${partner.name} ${partner.rate}.xlsx`;
        importedSaveAs(res, filename);
      });
  }
}
